import React, {useEffect} from 'react';
import {UiBox, UiButton, UiCenter, UiImage, UiText} from '~/components/elements';
import {trackPageViewGA} from '~/services/google-analytics';

const ExpiredBookingAppointment = () => {
  const onClickNoSlot = () => {
    let postMessage: {
      func: string;
      message: string;
      type?: number;
    } = {
      func: 'triggerChat',
      message: 'Trigger chat from iframe.',
    };
    if (window.parent) {
      window.parent.postMessage(postMessage, '*');
    }
  };

  useEffect(() => {
    trackPageViewGA('/expired-booking-appointment', 'Expired Booking Appointment');
  }, []);

  return (
    <UiBox px={4}>
      <UiCenter>
        <UiImage type="icon" name="ease-logo" width="120px" mt={6} />
      </UiCenter>
      <UiBox mt="50px">
        <UiText textAlign="center" fontSize={['33px', '40px']} fontWeight="500" mb="20px">
          Oops, your booking appointment link has expired.
        </UiText>
        <UiCenter>
          <UiButton mt={10} onClick={onClickNoSlot}>
            Contact Us
          </UiButton>
        </UiCenter>
        <UiText textAlign="center" fontSize="md" mt={10}>
          If you want to reschedule your upcoming appointment, please reach out to us at
        </UiText>
        <UiText textAlign="center" fontSize="md">
          customer.care@ease-healthcare.com.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          The Ease Healthcare Team
        </UiText>
      </UiBox>
    </UiBox>
  );
};

export default ExpiredBookingAppointment;
